export const HOME_DOMAIN = `https://${process.env.NEXT_PUBLIC_APP_DOMAIN}`
export const TREUUNFE_WEB_SITE_URL = `https://www.treeunfe.com.br`

export const ACCESS_TOKEN_KEY = `@treeunfe:access_token${
  process.env.NEXT_PUBLIC_ENVIRONMENT === 'production' ? '' : '_dev'
}`

export const REFRESH_TOKEN_KEY = `@treeunfe:refresh_token${
  process.env.NEXT_PUBLIC_ENVIRONMENT === 'production' ? '' : '_dev'
}`

export const PRODUCT_COLORS = Object.freeze({
  NFE: '#14AE5C',
  NFCE: '#EA580C',
  CTE: '#144AAE',
  MDFE: '#DA4B4B',
})

export const metaDescription =
  'Um emissor simples e ágil para emitir suas notas fiscais online de qualquer lugar. Você não precisa ir para um sistema de gestão complexo e cheio de coisas que você não vai usar. A Treeunfe é feita para você que quer emitir documentos fiscais de forma rápida e fácil.'

export const staticCategories = [
  'Vendas',
  'Institucional',
  'Podcast',
  'Notícias',
  'Tributário',
  'Tutoriais',
  'Dicas',
  'Informação',
  'Fiscal',
  'Empreendedorismo',
  'MEI',
]

export const fadeInBlur = {
  hidden: { opacity: 0, filter: 'blur(8px)', y: 10 },
  visible: {
    opacity: 1,
    filter: 'blur(0px)',
    y: 0,
    transition: { duration: 0.4 },
  },
}

export const isProduction = process.env.NEXT_PUBLIC_ENVIROMENT === 'production'
export const fallbackDomain = process.env.NEXT_PUBLIC_APP_DOMAIN || 'localhost'

export const cookieOptions = {
  maxAge: 30 * 24 * 60 * 60, // 30 dias
  path: '/',
  domain: fallbackDomain,
  secure: isProduction,
  httpOnly: false,
  sameSite: 'Strict' as const,
}
